export default "__VITE_ASSET__CPiVImjn__"